import React from 'react'
import { useAuth } from '../providers/AuthProvider'
import { Navigate, Outlet } from 'react-router-dom';

const GateKeeper = () => {

	const { user } = useAuth();

	const defaultRoute = '/login'

  return (
		user ? <Outlet/> : <Navigate to={defaultRoute}/>
	)
}

export default GateKeeper